// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ruBl","field":"styles_field__2LsCk","fieldCol":"styles_fieldCol__2XC__","diffCol":"styles_diffCol__29Fb6","diff":"styles_diff__2KLZO"};